import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { ERoute } from "./routes/routes";
import Login from "./pages/Login/Login";
import Dashboard from "./pages/Dashboard/Dashboard";
import styles from "./App.module.scss";
import classNames from "classnames";
import Home from "./pages/Dashboard/components/Home/Home";
import Movies from "./pages/Dashboard/components/Movies/Movies";
import Series from "./pages/Dashboard/components/Series/Series";
import Bookmarked from "./pages/Dashboard/components/Bookmarked/Bookmarked";

function App() {
  return (
    <div className={classNames(styles.App)}>
      <Routes>
        <Route path={ERoute.DEFAULT} element={<Navigate to={ERoute.LOGIN} />} />
        <Route path={ERoute.LOGIN} element={<Login />} />
        <Route path={ERoute.SIGNUP} element={<Login />} />
        <Route path={ERoute.DASHBOARD} element={<Dashboard />}>
          <Route index element={<Home />} />
          <Route path={ERoute.FILM} element={<Movies />} />
          <Route path={ERoute.SERIES} element={<Series />} />
          <Route path={ERoute.SAVED} element={<Bookmarked />} />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
